export default __webpack_public_path__ + "static/media/14457 - qoob.d2e6f11a.jpeg";